export enum EEventItemType {
    PLAYER = 'player',
    GAME = 'game',
    SHIFT = 'shift'
}

export interface IEventStateModel {
    playerEventDefinitions: IPlayerEventDefinition[] | undefined;
    gameEventDefinitions: IGameEventDefinition[] | undefined;
    shiftEventDefinitions: IShiftEventDefinition[] | undefined;
    flagDefinitions: IFlagDefinition[] | undefined;
    gameEvents: IGameEvent[] | undefined;
    playerEvents: IPlayerEvent[] | undefined;
    playerShiftEvents: IPlayerEventShiftsApiResponse[] | undefined;
}

export interface IPlayerEventDefinition {
    id: string;
    label: string;
    name: string;
    type: string;
    outcome: string;
    zone: string;
    isRelatedToGameEvents: boolean;
}

export interface IGameEventDefinition {
    id: string;
    label: string;
    name: string;
    type: string;
    clockImpact: ClockImpactType;
    playImpact: string;
}

export interface IShiftEventDefinition {
    id: string;
    name: string;
    shorthand: string;
}

export interface IFlagDefinition {
    id: string;
    label: string;
    name: string;
    requiresPlayersInvolved: boolean;
}

export enum ClockImpactType {
    start = 'start',
    stop = 'stop',
    /** For events that occur when the clock has stopped but something is happening, e.g. shootout goal */
    none = 'none',
    /** For events that occur when the clock has stopped but something is happening, e.g. shootout stop */
    stoppedPlayEnd = 'stoppedplayend',
    /** For events that occur when the clock has stopped but something is happening, e.g. shootout start */
    stoppedPlayStart = 'stoppedplaystart'
}

export interface IGameEvent {
    id: string;
    gameId: string;
    teamId: string;
    playerId: string;
    period: number;
    frame: number;
    defId: string;
    createdBy: string;
    periodTime: number;
    gameTime: number;
    updatedOn: string;
}

export interface IPlayerEvent {
    gameId: string;
    teamId: string;
    playerId: string;
    secondaryPlayerId: string;
    period: number;
    frame: number;
    defId: string;
    vidId: string;
    createdBy: string;
    id: string;
    updatedOn: string;
    periodTime: number;
    gameTime: number;
    xCoord: number;
    yCoord: number;
    yAdjCoord: number;
    xAdjCoord: number;
    flags: string[];
    flagIds: string[];
}

export interface IGameEventsRequestParams {
    gameeventid?: string[];
    gameeventname?: string[];
    gameid?: string[];
    leagueid?: string[];
    seasonid?: string[];
    seasonstage?: string[];
    teamid?: string[];
    playerid?: string[];
    period?: number[];
    includeoutofsequenceevents?: boolean;
}

export enum EPlayerEventsMode {
    COMPILED = 'compiled',
    RAW = 'raw',
    LIVE = 'live'
}

export interface IPlayerEventsRequestParams {
    playereventid?: string[];
    playereventname?: string[];
    gameid?: string[];
    leagueid?: string[];
    seasonid?: string[];
    teamid?: string[];
    seasonstage?: string[];
    playerid?: string[];
    period?: number[];
    mode?: EPlayerEventsMode;
    excludegameevents?: boolean;
    withplayers?: boolean;
    withflagdefinitions?: boolean;
}

export interface IPlayerShiftEventsRequestParams {
    gameid?: string[];
    leagueid?: string;
    teamid?: string;
    seasonid?: string;
    seasonstage?: string;
    playerid?: string[];
    period?: number[];
}

export interface IPlayerEventShiftsApiResponse {
    id: string;
    playerId: string;
    gameId: string;
    teamId: string;
    period: number;
    playerShiftEventDefinitionId: string;
    frame: number;
    linkedshifteventid: string;
    createdBy: string;
    createdOn: string;
}

export interface IGameEventPayload {
    defId: string;
    frame: number;
    period: number;
    periodTime: string;
    playerId: string;
    sourceId: string;
    teamId: string;
    vidId: string;
}

export interface IPlayerEventPayload {
    gameId: string;
    teamId: string;
    playerId: string;
    secondaryPlayerId: string | null;
    period: number;
    frame: number;
    defId: string;
    vidId: string;
    linkedGameEventId: string | null;
    xRinkCoord: number | null;
    yRinkCoord: number | null;
    xPixelCoord: number | null;
    yPixelCoord: number | null;
    officialPeriodTime: string | null;
    teamPlayersInvolvedInPlay: number | null;
    opposingTeamPlayersInvolvedInPlay: number | null;
    sourceId: string | null;
    flagIds: string[] | null;
}

export interface ICreateEventApiResponse {
    eventIds: string[];
}
